import React from 'react';
import styled from 'styled-components';
import { spacer8, spacer16, spacer24, spacer32, screenMdMin, display1FontSizeXSmall, heading2FontSize, white, black, spacer48, spacer40, screenSmMin, screenXsMax, Type } from '@spotify-internal/encore-web';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { Box, Link, Supertext, StyledSupertext } from '../../ui';
import { youtubeIdRegex } from '../../utils';
import { VideoComponent } from '../../ui/Video';
import { ShareButtonsComponent } from '../../ui/ShareButtons';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled(Box).withConfig({
  displayName: "VideoModule__Wrapper",
  componentId: "khtnv7-0"
})(["color:", ";display:flex;flex-flow:row-reverse wrap;justify-content:space-between;height:auto;background:", ";&{padding:", " ", ";}@media (min-width:", ") and (max-width:", "){", "{padding-top:", ";}}@media (max-width:", "){padding-left:", ";padding-right:", ";p{padding-top:", ";}}@media (max-width:", "){flex-direction:column;justify-content:flex-start;padding-bottom:", ";}"], white, black, spacer48, spacer40, screenSmMin, screenMdMin, StyledSupertext, spacer32, screenXsMax, spacer16, spacer16, spacer16, screenMdMin, spacer32);
var InnerText = styled.div.withConfig({
  displayName: "VideoModule__InnerText",
  componentId: "khtnv7-1"
})(["padding-left:0px;width:30%;display:flex;flex-direction:column;justify-content:space-evenly;@media (max-width:", "){justify-content:flex-start;width:100%;margin:0px;}"], screenMdMin);
var VideoWrapper = styled.div.withConfig({
  displayName: "VideoModule__VideoWrapper",
  componentId: "khtnv7-2"
})(["padding-left:0px;width:65%;@media (max-width:", "){padding-bottom:", ";width:100%;margin:0px;}"], screenMdMin, spacer8); // TODO Remove hardcoding of font-size - there is no 56 in Encore, it is Frodor specific

var Headline = styled(Type.h1).attrs({
  paddingBottom: '0.67em',
  variant: 'altoBrio',
  weight: 'bold'
}).withConfig({
  displayName: "VideoModule__Headline",
  componentId: "khtnv7-3"
})(["padding:", " 0;font-size:", ";max-width:684px;@media (max-width:", "){text-align:left;font-size:", ";padding:0;}"], spacer16, display1FontSizeXSmall, screenMdMin, heading2FontSize);
var Subtext = styled(Type.h4).attrs({
  variant: 'cello'
}).withConfig({
  displayName: "VideoModule__Subtext",
  componentId: "khtnv7-4"
})(["padding-bottom:", ";"], spacer24);
var AllVideosLink = styled(Link).withConfig({
  displayName: "VideoModule__AllVideosLink",
  componentId: "khtnv7-5"
})(["text-decoration:underline;color:", ";&:focus:not(:disabled),&:active:not(:disabled),&:visited:not(:disabled){color:", ";}&:hover:not(:disabled){color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.cta.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.cta.text;
}, function (_ref3) {
  var theme = _ref3.theme;
  return hexToRgba(theme.cta.text || white, 0.75);
});
var TRACK_CAT = 'module-video';
export var VideoModule = /*#__PURE__*/React.forwardRef(function (_ref4, _) {
  var _ref4$headline = _ref4.headline,
      headline = _ref4$headline === void 0 ? '' : _ref4$headline,
      _ref4$subtext = _ref4.subtext,
      subtext = _ref4$subtext === void 0 ? '' : _ref4$subtext,
      _ref4$supertext = _ref4.supertext,
      supertext = _ref4$supertext === void 0 ? '' : _ref4$supertext,
      _ref4$videoUrl = _ref4.videoUrl,
      videoUrl = _ref4$videoUrl === void 0 ? '' : _ref4$videoUrl;
  var t = useT();
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(VideoWrapper, {
      children: videoUrl.match(youtubeIdRegex) && /*#__PURE__*/_jsx(VideoComponent, {
        url: videoUrl
      })
    }), /*#__PURE__*/_jsxs(InnerText, {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [supertext && /*#__PURE__*/_jsx(Supertext, {
          children: supertext
        }), headline && /*#__PURE__*/_jsx(Headline, {
          "data-testid": "video-module-headline",
          children: headline
        }), subtext && /*#__PURE__*/_jsx(Subtext, {
          children: subtext
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(ShareButtonsComponent, {}), /*#__PURE__*/_jsx(AllVideosLink, {
          href: "/videos",
          track: [TRACK_CAT, 'All Videos Link'],
          children: t('FRODOR_VIDEO_MODULE_BACK_TO_VIDEOS', 'Back to videos', 'A link that when clicked will take the user back to All Videos')
        })]
      })]
    })]
  });
});